export const STORE_NAVIGATION_STATE = "auth/STORE_NAVIGATION_STATE";
export const GET_USERS = "users/GET_USERS";
export const DELETE_USER = "users/DELETE_USER";
export const ADD_USER = "users/ADD_USER";
export const GET_EXPORTERS = "exporters/GET_EXPORTERS";
export const DELETE_EXPORTER = "exporters/DELETE_EXPORTER";
export const ADD_EXPORTER = "exporters/ADD_EXPORTER";
export const UPDATE_EXPORTER = "exporters/UPDATE_EXPORTER";
export const ADD_AD_CODE = "exporters/ADD_AD_CODE";
export const DELETE_AD_CODE = "exporters/DELETE_AD_CODE";
export const GET_ACCOUNT_DETAILS = "account/GET_ACCOUNT_DETAILS";
export const UPDATE_ACCOUNT_SETTINGS = "account/UPDATE_ACCOUNT_SETTINGS";
export const UPDATE_USER_NAME = "profile/UPDATE_USER_NAME";
export const ADD_TIME_PERIOD = "account/ADD_TIME_PERIOD";
export const GET_TIME_PERIODS = "account/GET_TIME_PERIODS";
export const DELETE_TIME_PERIOD = "account/DELETE_TIME_PERIOD";
export const EDIT_TIME_PERIOD = "account/EDIT_TIME_PERIOD";
export const UPDATE_TIME_PERIOD = "account/UPDATE_TIME_PERIOD";
export const ADD_NOTIFICATION_REQUEST = "account/ADD_NOTIFICATION_REQUEST";
